import React, { useState } from "react";
import ReactDOM from "react-dom";
import { backdropStyle, modalStyle } from "DialogProviderShare";

interface EmojiEntry { emoji: string; name: string; section: string }

const EMOJI_LIST: EmojiEntry[] = [
  // ── Smileys ──────────────────────────────────────────────────────────────
  { emoji: "😀", name: "grinning face", section: "หน้าตา" },
  { emoji: "😃", name: "grinning big eyes", section: "หน้าตา" },
  { emoji: "😄", name: "grinning smiling eyes", section: "หน้าตา" },
  { emoji: "😁", name: "beaming smiling eyes", section: "หน้าตา" },
  { emoji: "😆", name: "grinning squinting", section: "หน้าตา" },
  { emoji: "😅", name: "grinning sweat", section: "หน้าตา" },
  { emoji: "🤣", name: "rolling floor laughing", section: "หน้าตา" },
  { emoji: "😂", name: "tears of joy", section: "หน้าตา" },
  { emoji: "🙂", name: "slightly smiling", section: "หน้าตา" },
  { emoji: "🙃", name: "upside down", section: "หน้าตา" },
  { emoji: "🫠", name: "melting face", section: "หน้าตา" },
  { emoji: "😉", name: "winking face", section: "หน้าตา" },
  { emoji: "😊", name: "smiling eyes", section: "หน้าตา" },
  { emoji: "😇", name: "halo angel", section: "หน้าตา" },
  { emoji: "🥰", name: "smiling hearts", section: "หน้าตา" },
  { emoji: "😍", name: "heart eyes", section: "หน้าตา" },
  { emoji: "🤩", name: "star struck", section: "หน้าตา" },
  { emoji: "😘", name: "blowing kiss", section: "หน้าตา" },
  { emoji: "😗", name: "kissing face", section: "หน้าตา" },
  { emoji: "☺️", name: "smiling face", section: "หน้าตา" },
  { emoji: "😚", name: "kissing closed eyes", section: "หน้าตา" },
  { emoji: "😙", name: "kissing smiling eyes", section: "หน้าตา" },
  { emoji: "🥲", name: "smiling tear", section: "หน้าตา" },
  { emoji: "😋", name: "savoring food", section: "หน้าตา" },
  { emoji: "😛", name: "tongue out", section: "หน้าตา" },
  { emoji: "😜", name: "winking tongue", section: "หน้าตา" },
  { emoji: "🤪", name: "zany face", section: "หน้าตา" },
  { emoji: "😝", name: "squinting tongue", section: "หน้าตา" },
  { emoji: "🤑", name: "money mouth", section: "หน้าตา" },
  { emoji: "🤗", name: "hugging face", section: "หน้าตา" },
  { emoji: "🤭", name: "hand over mouth", section: "หน้าตา" },
  { emoji: "🫢", name: "open eyes hand mouth", section: "หน้าตา" },
  { emoji: "🫣", name: "peeking eye", section: "หน้าตา" },
  { emoji: "🤫", name: "shushing face", section: "หน้าตา" },
  { emoji: "🤔", name: "thinking face", section: "หน้าตา" },
  { emoji: "🫡", name: "saluting face", section: "หน้าตา" },
  { emoji: "🤐", name: "zipper mouth", section: "หน้าตา" },
  { emoji: "🤨", name: "raised eyebrow", section: "หน้าตา" },
  { emoji: "😐", name: "neutral face", section: "หน้าตา" },
  { emoji: "😑", name: "expressionless", section: "หน้าตา" },
  { emoji: "😶", name: "no mouth", section: "หน้าตา" },
  { emoji: "😏", name: "smirking face", section: "หน้าตา" },
  { emoji: "😒", name: "unamused face", section: "หน้าตา" },
  { emoji: "🙄", name: "rolling eyes", section: "หน้าตา" },
  { emoji: "😬", name: "grimacing face", section: "หน้าตา" },
  { emoji: "🤥", name: "lying face", section: "หน้าตา" },
  { emoji: "😌", name: "relieved face", section: "หน้าตา" },
  { emoji: "😔", name: "pensive face", section: "หน้าตา" },
  { emoji: "😪", name: "sleepy face", section: "หน้าตา" },
  { emoji: "🤤", name: "drooling face", section: "หน้าตา" },
  { emoji: "😴", name: "sleeping face", section: "หน้าตา" },
  { emoji: "😷", name: "medical mask", section: "หน้าตา" },
  { emoji: "🤒", name: "thermometer sick", section: "หน้าตา" },
  { emoji: "🤕", name: "head bandage", section: "หน้าตา" },
  { emoji: "🤢", name: "nauseated face", section: "หน้าตา" },
  { emoji: "🤮", name: "vomiting face", section: "หน้าตา" },
  { emoji: "🤧", name: "sneezing face", section: "หน้าตา" },
  { emoji: "🥵", name: "hot face", section: "หน้าตา" },
  { emoji: "🥶", name: "cold face", section: "หน้าตา" },
  { emoji: "🥴", name: "woozy face", section: "หน้าตา" },
  { emoji: "😵", name: "dizzy face", section: "หน้าตา" },
  { emoji: "🤯", name: "exploding head", section: "หน้าตา" },
  { emoji: "🤠", name: "cowboy hat", section: "หน้าตา" },
  { emoji: "🥳", name: "partying face", section: "หน้าตา" },
  { emoji: "🥸", name: "disguised face", section: "หน้าตา" },
  { emoji: "😎", name: "sunglasses cool", section: "หน้าตา" },
  { emoji: "🤓", name: "nerd face", section: "หน้าตา" },
  { emoji: "🧐", name: "monocle face", section: "หน้าตา" },
  { emoji: "😕", name: "confused face", section: "หน้าตา" },
  { emoji: "🫤", name: "diagonal mouth", section: "หน้าตา" },
  { emoji: "😟", name: "worried face", section: "หน้าตา" },
  { emoji: "🙁", name: "slightly frowning", section: "หน้าตา" },
  { emoji: "☹️", name: "frowning face", section: "หน้าตา" },
  { emoji: "😮", name: "open mouth", section: "หน้าตา" },
  { emoji: "😯", name: "hushed face", section: "หน้าตา" },
  { emoji: "😲", name: "astonished face", section: "หน้าตา" },
  { emoji: "😳", name: "flushed face", section: "หน้าตา" },
  { emoji: "🥺", name: "pleading face", section: "หน้าตา" },
  { emoji: "🥹", name: "holding back tears", section: "หน้าตา" },
  { emoji: "😦", name: "frowning open mouth", section: "หน้าตา" },
  { emoji: "😧", name: "anguished face", section: "หน้าตา" },
  { emoji: "😨", name: "fearful face", section: "หน้าตา" },
  { emoji: "😰", name: "anxious sweat", section: "หน้าตา" },
  { emoji: "😥", name: "sad relieved", section: "หน้าตา" },
  { emoji: "😢", name: "crying face", section: "หน้าตา" },
  { emoji: "😭", name: "loudly crying", section: "หน้าตา" },
  { emoji: "😱", name: "screaming fear", section: "หน้าตา" },
  { emoji: "😖", name: "confounded face", section: "หน้าตา" },
  { emoji: "😣", name: "persevering face", section: "หน้าตา" },
  { emoji: "😞", name: "disappointed face", section: "หน้าตา" },
  { emoji: "😓", name: "downcast sweat", section: "หน้าตา" },
  { emoji: "😩", name: "weary face", section: "หน้าตา" },
  { emoji: "😫", name: "tired face", section: "หน้าตา" },
  { emoji: "🥱", name: "yawning face", section: "หน้าตา" },
  { emoji: "😤", name: "steam nose", section: "หน้าตา" },
  { emoji: "😡", name: "enraged face", section: "หน้าตา" },
  { emoji: "😠", name: "angry face", section: "หน้าตา" },
  { emoji: "🤬", name: "symbols on mouth", section: "หน้าตา" },
  { emoji: "😈", name: "smiling horns devil", section: "หน้าตา" },
  { emoji: "👿", name: "angry horns devil", section: "หน้าตา" },
  { emoji: "💀", name: "skull death", section: "หน้าตา" },
  { emoji: "☠️", name: "skull crossbones", section: "หน้าตา" },
  { emoji: "💩", name: "pile of poo", section: "หน้าตา" },
  { emoji: "🤡", name: "clown face", section: "หน้าตา" },
  { emoji: "👹", name: "ogre monster", section: "หน้าตา" },
  { emoji: "👺", name: "goblin", section: "หน้าตา" },
  { emoji: "👻", name: "ghost", section: "หน้าตา" },
  { emoji: "👽", name: "alien", section: "หน้าตา" },
  { emoji: "👾", name: "alien monster", section: "หน้าตา" },
  { emoji: "🤖", name: "robot", section: "หน้าตา" },
  { emoji: "😺", name: "grinning cat", section: "หน้าตา" },
  { emoji: "😸", name: "cat smiling eyes", section: "หน้าตา" },
  { emoji: "😹", name: "cat tears joy", section: "หน้าตา" },
  { emoji: "😻", name: "cat heart eyes", section: "หน้าตา" },
  { emoji: "😼", name: "cat wry smile", section: "หน้าตา" },
  { emoji: "😽", name: "kissing cat", section: "หน้าตา" },
  { emoji: "🙀", name: "weary cat", section: "หน้าตา" },
  { emoji: "😿", name: "crying cat", section: "หน้าตา" },
  { emoji: "😾", name: "pouting cat", section: "หน้าตา" },

  // ── Gestures & Body Parts ─────────────────────────────────────────────────
  { emoji: "👋", name: "waving hand", section: "ท่าทาง" },
  { emoji: "🤚", name: "raised back hand", section: "ท่าทาง" },
  { emoji: "🖐️", name: "hand fingers splayed", section: "ท่าทาง" },
  { emoji: "✋", name: "raised hand", section: "ท่าทาง" },
  { emoji: "🖖", name: "vulcan salute", section: "ท่าทาง" },
  { emoji: "🫱", name: "rightwards hand", section: "ท่าทาง" },
  { emoji: "🫲", name: "leftwards hand", section: "ท่าทาง" },
  { emoji: "🫳", name: "palm down", section: "ท่าทาง" },
  { emoji: "🫴", name: "palm up", section: "ท่าทาง" },
  { emoji: "👌", name: "ok hand", section: "ท่าทาง" },
  { emoji: "🤌", name: "pinched fingers", section: "ท่าทาง" },
  { emoji: "🤏", name: "pinching hand", section: "ท่าทาง" },
  { emoji: "✌️", name: "victory peace", section: "ท่าทาง" },
  { emoji: "🤞", name: "crossed fingers", section: "ท่าทาง" },
  { emoji: "🫰", name: "index thumb crossed", section: "ท่าทาง" },
  { emoji: "🤟", name: "love you gesture", section: "ท่าทาง" },
  { emoji: "🤘", name: "sign of horns", section: "ท่าทาง" },
  { emoji: "🤙", name: "call me hand", section: "ท่าทาง" },
  { emoji: "👈", name: "pointing left", section: "ท่าทาง" },
  { emoji: "👉", name: "pointing right", section: "ท่าทาง" },
  { emoji: "👆", name: "pointing up", section: "ท่าทาง" },
  { emoji: "🖕", name: "middle finger", section: "ท่าทาง" },
  { emoji: "👇", name: "pointing down", section: "ท่าทาง" },
  { emoji: "☝️", name: "index pointing up", section: "ท่าทาง" },
  { emoji: "🫵", name: "pointing at viewer", section: "ท่าทาง" },
  { emoji: "👍", name: "thumbs up like", section: "ท่าทาง" },
  { emoji: "👎", name: "thumbs down dislike", section: "ท่าทาง" },
  { emoji: "✊", name: "raised fist", section: "ท่าทาง" },
  { emoji: "👊", name: "oncoming fist punch", section: "ท่าทาง" },
  { emoji: "🤛", name: "left facing fist", section: "ท่าทาง" },
  { emoji: "🤜", name: "right facing fist", section: "ท่าทาง" },
  { emoji: "👏", name: "clapping hands", section: "ท่าทาง" },
  { emoji: "🙌", name: "raising hands", section: "ท่าทาง" },
  { emoji: "🫶", name: "heart hands", section: "ท่าทาง" },
  { emoji: "👐", name: "open hands", section: "ท่าทาง" },
  { emoji: "🤲", name: "palms up together", section: "ท่าทาง" },
  { emoji: "🤝", name: "handshake", section: "ท่าทาง" },
  { emoji: "🙏", name: "folded hands pray", section: "ท่าทาง" },
  { emoji: "✍️", name: "writing hand", section: "ท่าทาง" },
  { emoji: "💅", name: "nail polish", section: "ท่าทาง" },
  { emoji: "🤳", name: "selfie", section: "ท่าทาง" },
  { emoji: "💪", name: "flexed biceps muscle", section: "ท่าทาง" },
  { emoji: "🦾", name: "mechanical arm", section: "ท่าทาง" },
  { emoji: "🦵", name: "leg", section: "ท่าทาง" },
  { emoji: "🦶", name: "foot", section: "ท่าทาง" },
  { emoji: "👂", name: "ear", section: "ท่าทาง" },
  { emoji: "🦻", name: "ear hearing aid", section: "ท่าทาง" },
  { emoji: "👃", name: "nose", section: "ท่าทาง" },
  { emoji: "🧠", name: "brain", section: "ท่าทาง" },
  { emoji: "🫀", name: "anatomical heart", section: "ท่าทาง" },
  { emoji: "🫁", name: "lungs", section: "ท่าทาง" },
  { emoji: "🦷", name: "tooth", section: "ท่าทาง" },
  { emoji: "🦴", name: "bone", section: "ท่าทาง" },
  { emoji: "👀", name: "eyes", section: "ท่าทาง" },
  { emoji: "👁️", name: "eye", section: "ท่าทาง" },
  { emoji: "👅", name: "tongue", section: "ท่าทาง" },
  { emoji: "👄", name: "mouth lips", section: "ท่าทาง" },
  { emoji: "🫦", name: "biting lip", section: "ท่าทาง" },

  // ── Clothing & Accessories ────────────────────────────────────────────────
  { emoji: "👓", name: "glasses", section: "เครื่องแต่งกาย" },
  { emoji: "🕶️", name: "sunglasses", section: "เครื่องแต่งกาย" },
  { emoji: "🥽", name: "goggles", section: "เครื่องแต่งกาย" },
  { emoji: "🌂", name: "closed umbrella", section: "เครื่องแต่งกาย" },
  { emoji: "☂️", name: "umbrella", section: "เครื่องแต่งกาย" },
  { emoji: "🧵", name: "thread sewing", section: "เครื่องแต่งกาย" },
  { emoji: "🪡", name: "sewing needle", section: "เครื่องแต่งกาย" },
  { emoji: "🧶", name: "yarn knitting", section: "เครื่องแต่งกาย" },
  { emoji: "🪢", name: "knot rope", section: "เครื่องแต่งกาย" },
  { emoji: "👒", name: "womans hat", section: "เครื่องแต่งกาย" },
  { emoji: "🎩", name: "top hat", section: "เครื่องแต่งกาย" },
  { emoji: "🎓", name: "graduation cap", section: "เครื่องแต่งกาย" },
  { emoji: "🪖", name: "military helmet", section: "เครื่องแต่งกาย" },
  { emoji: "⛑️", name: "rescue helmet", section: "เครื่องแต่งกาย" },
  { emoji: "💄", name: "lipstick", section: "เครื่องแต่งกาย" },
  { emoji: "💍", name: "ring", section: "เครื่องแต่งกาย" },
  { emoji: "💎", name: "gem diamond", section: "เครื่องแต่งกาย" },
  { emoji: "👔", name: "necktie shirt", section: "เครื่องแต่งกาย" },
  { emoji: "👕", name: "t-shirt", section: "เครื่องแต่งกาย" },
  { emoji: "👖", name: "jeans denim", section: "เครื่องแต่งกาย" },
  { emoji: "🧣", name: "scarf", section: "เครื่องแต่งกาย" },
  { emoji: "🧤", name: "gloves", section: "เครื่องแต่งกาย" },
  { emoji: "🧥", name: "coat jacket", section: "เครื่องแต่งกาย" },
  { emoji: "🧦", name: "socks", section: "เครื่องแต่งกาย" },
  { emoji: "👗", name: "dress", section: "เครื่องแต่งกาย" },
  { emoji: "👘", name: "kimono", section: "เครื่องแต่งกาย" },
  { emoji: "🥻", name: "sari", section: "เครื่องแต่งกาย" },
  { emoji: "🩱", name: "one piece swimsuit", section: "เครื่องแต่งกาย" },
  { emoji: "🩲", name: "briefs underwear", section: "เครื่องแต่งกาย" },
  { emoji: "🩳", name: "shorts", section: "เครื่องแต่งกาย" },
  { emoji: "👙", name: "bikini", section: "เครื่องแต่งกาย" },
  { emoji: "👚", name: "womans clothes", section: "เครื่องแต่งกาย" },
  { emoji: "👛", name: "purse", section: "เครื่องแต่งกาย" },
  { emoji: "👜", name: "handbag", section: "เครื่องแต่งกาย" },
  { emoji: "👝", name: "clutch bag pouch", section: "เครื่องแต่งกาย" },
  { emoji: "🎒", name: "backpack", section: "เครื่องแต่งกาย" },
  { emoji: "🧳", name: "luggage suitcase", section: "เครื่องแต่งกาย" },
  { emoji: "👞", name: "mans shoe", section: "เครื่องแต่งกาย" },
  { emoji: "👟", name: "running shoe sneaker", section: "เครื่องแต่งกาย" },
  { emoji: "🥾", name: "hiking boot", section: "เครื่องแต่งกาย" },
  { emoji: "🥿", name: "flat shoe", section: "เครื่องแต่งกาย" },
  { emoji: "👠", name: "high heeled shoe", section: "เครื่องแต่งกาย" },
  { emoji: "👡", name: "womans sandal", section: "เครื่องแต่งกาย" },
  { emoji: "🩴", name: "thong sandal flip flop", section: "เครื่องแต่งกาย" },
  { emoji: "👢", name: "womans boot", section: "เครื่องแต่งกาย" },
  { emoji: "👑", name: "crown", section: "เครื่องแต่งกาย" },
  { emoji: "🎀", name: "ribbon bow", section: "เครื่องแต่งกาย" },

  // ── Animals & Nature ──────────────────────────────────────────────────────
  { emoji: "🐶", name: "dog face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐱", name: "cat face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐭", name: "mouse face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐹", name: "hamster", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐰", name: "rabbit face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦊", name: "fox", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐻", name: "bear", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐼", name: "panda", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐨", name: "koala", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐯", name: "tiger face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦁", name: "lion", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐮", name: "cow face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐷", name: "pig face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐸", name: "frog", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐵", name: "monkey face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🙈", name: "see no evil monkey", section: "สัตว์และธรรมชาติ" },
  { emoji: "🙉", name: "hear no evil monkey", section: "สัตว์และธรรมชาติ" },
  { emoji: "🙊", name: "speak no evil monkey", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐒", name: "monkey", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐔", name: "chicken", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐧", name: "penguin", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐦", name: "bird", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐤", name: "baby chick", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦆", name: "duck", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦅", name: "eagle", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦉", name: "owl", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦇", name: "bat", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐺", name: "wolf", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐗", name: "boar", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐴", name: "horse face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦄", name: "unicorn", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐝", name: "honeybee", section: "สัตว์และธรรมชาติ" },
  { emoji: "🪱", name: "worm", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐛", name: "bug caterpillar", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦋", name: "butterfly", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐌", name: "snail", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐞", name: "lady beetle ladybug", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐜", name: "ant", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦟", name: "mosquito", section: "สัตว์และธรรมชาติ" },
  { emoji: "🪲", name: "beetle", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦂", name: "scorpion", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐢", name: "turtle", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐍", name: "snake", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦎", name: "lizard", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐊", name: "crocodile", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦖", name: "t-rex dinosaur", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦕", name: "dinosaur sauropod", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐉", name: "dragon", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐲", name: "dragon face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐳", name: "whale spouting", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐋", name: "whale", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐬", name: "dolphin", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦭", name: "seal", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐟", name: "fish", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐠", name: "tropical fish", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐡", name: "blowfish", section: "สัตว์และธรรมชาติ" },
  { emoji: "🦈", name: "shark", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐙", name: "octopus", section: "สัตว์และธรรมชาติ" },
  { emoji: "🐚", name: "spiral shell", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌵", name: "cactus", section: "สัตว์และธรรมชาติ" },
  { emoji: "🎄", name: "christmas tree", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌲", name: "evergreen tree", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌳", name: "deciduous tree", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌴", name: "palm tree", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌱", name: "seedling sprout", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌿", name: "herb leaf", section: "สัตว์และธรรมชาติ" },
  { emoji: "☘️", name: "shamrock clover", section: "สัตว์และธรรมชาติ" },
  { emoji: "🍀", name: "four leaf clover luck", section: "สัตว์และธรรมชาติ" },
  { emoji: "🍃", name: "leaves wind", section: "สัตว์และธรรมชาติ" },
  { emoji: "🍂", name: "fallen leaf autumn", section: "สัตว์และธรรมชาติ" },
  { emoji: "🍁", name: "maple leaf", section: "สัตว์และธรรมชาติ" },
  { emoji: "🍄", name: "mushroom", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌾", name: "rice sheaf", section: "สัตว์และธรรมชาติ" },
  { emoji: "💐", name: "bouquet flowers", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌷", name: "tulip", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌹", name: "rose", section: "สัตว์และธรรมชาติ" },
  { emoji: "🥀", name: "wilted flower", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌺", name: "hibiscus", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌸", name: "cherry blossom", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌼", name: "blossom", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌻", name: "sunflower", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌞", name: "sun with face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌝", name: "full moon face", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌙", name: "crescent moon", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌟", name: "glowing star", section: "สัตว์และธรรมชาติ" },
  { emoji: "⭐", name: "star", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌠", name: "shooting star", section: "สัตว์และธรรมชาติ" },
  { emoji: "☀️", name: "sun sunny", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌤️", name: "sun small cloud", section: "สัตว์และธรรมชาติ" },
  { emoji: "⛅", name: "sun behind cloud", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌧️", name: "cloud rain", section: "สัตว์และธรรมชาติ" },
  { emoji: "⛈️", name: "thunder rain", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌩️", name: "cloud lightning", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌨️", name: "cloud snow", section: "สัตว์และธรรมชาติ" },
  { emoji: "❄️", name: "snowflake cold", section: "สัตว์และธรรมชาติ" },
  { emoji: "☃️", name: "snowman", section: "สัตว์และธรรมชาติ" },
  { emoji: "💨", name: "wind dashing away", section: "สัตว์และธรรมชาติ" },
  { emoji: "💧", name: "droplet water", section: "สัตว์และธรรมชาติ" },
  { emoji: "💦", name: "sweat droplets", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌊", name: "water wave ocean", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌈", name: "rainbow", section: "สัตว์และธรรมชาติ" },
  { emoji: "⚡", name: "lightning bolt", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌀", name: "cyclone", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌪️", name: "tornado", section: "สัตว์และธรรมชาติ" },
  { emoji: "🌋", name: "volcano", section: "สัตว์และธรรมชาติ" },

  // ── Food & Drink ──────────────────────────────────────────────────────────
  { emoji: "🍇", name: "grapes", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍈", name: "melon", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍉", name: "watermelon", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍊", name: "tangerine orange", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍋", name: "lemon", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍌", name: "banana", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍍", name: "pineapple", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥭", name: "mango", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍎", name: "red apple", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍏", name: "green apple", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍐", name: "pear", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍑", name: "peach", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍒", name: "cherries", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍓", name: "strawberry", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🫐", name: "blueberries", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥝", name: "kiwi fruit", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍅", name: "tomato", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥥", name: "coconut", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥑", name: "avocado", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍆", name: "eggplant", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥔", name: "potato", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥕", name: "carrot", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🌽", name: "corn", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🌶️", name: "hot pepper chili", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥒", name: "cucumber", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥬", name: "leafy green vegetable", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥦", name: "broccoli", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧄", name: "garlic", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧅", name: "onion", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍞", name: "bread", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥐", name: "croissant", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥖", name: "baguette bread", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥨", name: "pretzel", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥯", name: "bagel", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧀", name: "cheese", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥚", name: "egg", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍳", name: "cooking fried egg", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥞", name: "pancakes", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧇", name: "waffle", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥓", name: "bacon", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥩", name: "cut of meat steak", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍗", name: "poultry leg chicken", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍖", name: "meat on bone", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🌭", name: "hot dog", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍔", name: "hamburger burger", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍟", name: "french fries", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍕", name: "pizza", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🌮", name: "taco", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🌯", name: "burrito wrap", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥗", name: "green salad", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥘", name: "shallow pan food", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍝", name: "spaghetti pasta", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍜", name: "steaming bowl noodle", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍲", name: "pot of food stew", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍛", name: "curry rice", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍣", name: "sushi", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍱", name: "bento box", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥟", name: "dumpling", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍤", name: "fried shrimp", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍙", name: "rice ball", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍚", name: "cooked rice", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍘", name: "rice cracker", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧁", name: "cupcake", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍰", name: "cake shortcake", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🎂", name: "birthday cake", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍭", name: "lollipop candy", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍬", name: "candy sweet", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍫", name: "chocolate bar", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍿", name: "popcorn", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍩", name: "doughnut donut", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍪", name: "cookie", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍯", name: "honey pot", section: "อาหารและเครื่องดื่ม" },
  { emoji: "☕", name: "hot coffee beverage", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍵", name: "teacup tea", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧋", name: "bubble tea boba", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥤", name: "cup with straw drink", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧃", name: "juice box beverage", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍺", name: "beer mug", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍻", name: "clinking beer mugs", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥂", name: "clinking glasses champagne", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍷", name: "wine glass", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥃", name: "tumbler glass whisky", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍸", name: "cocktail glass", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍹", name: "tropical drink", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍾", name: "bottle popping cork", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧊", name: "ice cube", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥄", name: "spoon", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍴", name: "fork and knife", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🍽️", name: "fork knife plate", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🥢", name: "chopsticks", section: "อาหารและเครื่องดื่ม" },
  { emoji: "🧂", name: "salt shaker", section: "อาหารและเครื่องดื่ม" },

  // ── Activity & Sport ──────────────────────────────────────────────────────
  { emoji: "⚽", name: "soccer ball football", section: "กิจกรรมและกีฬา" },
  { emoji: "🏀", name: "basketball", section: "กิจกรรมและกีฬา" },
  { emoji: "🏈", name: "american football", section: "กิจกรรมและกีฬา" },
  { emoji: "⚾", name: "baseball", section: "กิจกรรมและกีฬา" },
  { emoji: "🥎", name: "softball", section: "กิจกรรมและกีฬา" },
  { emoji: "🎾", name: "tennis", section: "กิจกรรมและกีฬา" },
  { emoji: "🏐", name: "volleyball", section: "กิจกรรมและกีฬา" },
  { emoji: "🏉", name: "rugby football", section: "กิจกรรมและกีฬา" },
  { emoji: "🥏", name: "flying disc frisbee", section: "กิจกรรมและกีฬา" },
  { emoji: "🎱", name: "pool 8 ball billiard", section: "กิจกรรมและกีฬา" },
  { emoji: "🏓", name: "ping pong table tennis", section: "กิจกรรมและกีฬา" },
  { emoji: "🏸", name: "badminton", section: "กิจกรรมและกีฬา" },
  { emoji: "🏒", name: "ice hockey", section: "กิจกรรมและกีฬา" },
  { emoji: "🏑", name: "field hockey", section: "กิจกรรมและกีฬา" },
  { emoji: "🏏", name: "cricket", section: "กิจกรรมและกีฬา" },
  { emoji: "⛳", name: "golf flag hole", section: "กิจกรรมและกีฬา" },
  { emoji: "🎣", name: "fishing pole", section: "กิจกรรมและกีฬา" },
  { emoji: "🤿", name: "diving mask", section: "กิจกรรมและกีฬา" },
  { emoji: "🎿", name: "skis skiing", section: "กิจกรรมและกีฬา" },
  { emoji: "🛷", name: "sled sledge", section: "กิจกรรมและกีฬา" },
  { emoji: "🥌", name: "curling stone", section: "กิจกรรมและกีฬา" },
  { emoji: "🎯", name: "bullseye target", section: "กิจกรรมและกีฬา" },
  { emoji: "🎮", name: "video game controller", section: "กิจกรรมและกีฬา" },
  { emoji: "🕹️", name: "joystick", section: "กิจกรรมและกีฬา" },
  { emoji: "🎲", name: "game die dice", section: "กิจกรรมและกีฬา" },
  { emoji: "♟️", name: "chess pawn", section: "กิจกรรมและกีฬา" },
  { emoji: "🧩", name: "puzzle jigsaw", section: "กิจกรรมและกีฬา" },
  { emoji: "🪆", name: "nesting dolls", section: "กิจกรรมและกีฬา" },
  { emoji: "🪅", name: "pinata", section: "กิจกรรมและกีฬา" },
  { emoji: "🎭", name: "performing arts theatre", section: "กิจกรรมและกีฬา" },
  { emoji: "🎨", name: "artist palette paint", section: "กิจกรรมและกีฬา" },
  { emoji: "🖼️", name: "framed picture art", section: "กิจกรรมและกีฬา" },
  { emoji: "🎪", name: "circus tent", section: "กิจกรรมและกีฬา" },
  { emoji: "🎬", name: "clapper board movie", section: "กิจกรรมและกีฬา" },
  { emoji: "🎤", name: "microphone singing", section: "กิจกรรมและกีฬา" },
  { emoji: "🎧", name: "headphone music", section: "กิจกรรมและกีฬา" },
  { emoji: "🎷", name: "saxophone jazz", section: "กิจกรรมและกีฬา" },
  { emoji: "🎸", name: "guitar music", section: "กิจกรรมและกีฬา" },
  { emoji: "🎹", name: "piano keyboard music", section: "กิจกรรมและกีฬา" },
  { emoji: "🎺", name: "trumpet", section: "กิจกรรมและกีฬา" },
  { emoji: "🎻", name: "violin", section: "กิจกรรมและกีฬา" },
  { emoji: "🪕", name: "banjo", section: "กิจกรรมและกีฬา" },
  { emoji: "🥁", name: "drum", section: "กิจกรรมและกีฬา" },
  { emoji: "🎵", name: "musical note", section: "กิจกรรมและกีฬา" },
  { emoji: "🎶", name: "musical notes", section: "กิจกรรมและกีฬา" },
  { emoji: "🏆", name: "trophy award winner", section: "กิจกรรมและกีฬา" },
  { emoji: "🥇", name: "gold medal 1st place", section: "กิจกรรมและกีฬา" },
  { emoji: "🥈", name: "silver medal 2nd place", section: "กิจกรรมและกีฬา" },
  { emoji: "🥉", name: "bronze medal 3rd place", section: "กิจกรรมและกีฬา" },
  { emoji: "🏅", name: "sports medal", section: "กิจกรรมและกีฬา" },
  { emoji: "🎖️", name: "military medal", section: "กิจกรรมและกีฬา" },
  { emoji: "🎗️", name: "reminder ribbon", section: "กิจกรรมและกีฬา" },
  { emoji: "🎫", name: "ticket", section: "กิจกรรมและกีฬา" },
  { emoji: "🎟️", name: "admission tickets", section: "กิจกรรมและกีฬา" },
  { emoji: "🥊", name: "boxing glove", section: "กิจกรรมและกีฬา" },
  { emoji: "🥋", name: "martial arts uniform", section: "กิจกรรมและกีฬา" },
  { emoji: "🎽", name: "running shirt", section: "กิจกรรมและกีฬา" },
  { emoji: "🛹", name: "skateboard", section: "กิจกรรมและกีฬา" },
  { emoji: "🛼", name: "roller skate", section: "กิจกรรมและกีฬา" },
  { emoji: "🪂", name: "parachute", section: "กิจกรรมและกีฬา" },
  { emoji: "🏋️", name: "weightlifting gym", section: "กิจกรรมและกีฬา" },
  { emoji: "🤼", name: "wrestling", section: "กิจกรรมและกีฬา" },
  { emoji: "🤸", name: "cartwheel gymnastics", section: "กิจกรรมและกีฬา" },
  { emoji: "🏌️", name: "golfing", section: "กิจกรรมและกีฬา" },
  { emoji: "🏄", name: "surfing", section: "กิจกรรมและกีฬา" },
  { emoji: "🏊", name: "swimming", section: "กิจกรรมและกีฬา" },
  { emoji: "🚣", name: "rowing boat", section: "กิจกรรมและกีฬา" },
  { emoji: "🧗", name: "climbing", section: "กิจกรรมและกีฬา" },
  { emoji: "🚵", name: "mountain biking", section: "กิจกรรมและกีฬา" },
  { emoji: "🚴", name: "cycling biking", section: "กิจกรรมและกีฬา" },
  { emoji: "🏇", name: "horse racing", section: "กิจกรรมและกีฬา" },
  { emoji: "⛷️", name: "skier skiing", section: "กิจกรรมและกีฬา" },
  { emoji: "🏂", name: "snowboarder", section: "กิจกรรมและกีฬา" },

  // ── Travel & Place ────────────────────────────────────────────────────────
  { emoji: "🚗", name: "car automobile", section: "การเดินทาง" },
  { emoji: "🚕", name: "taxi", section: "การเดินทาง" },
  { emoji: "🚙", name: "suv vehicle", section: "การเดินทาง" },
  { emoji: "🚌", name: "bus", section: "การเดินทาง" },
  { emoji: "🏎️", name: "racing car", section: "การเดินทาง" },
  { emoji: "🚓", name: "police car", section: "การเดินทาง" },
  { emoji: "🚑", name: "ambulance", section: "การเดินทาง" },
  { emoji: "🚒", name: "fire engine truck", section: "การเดินทาง" },
  { emoji: "🚐", name: "minibus", section: "การเดินทาง" },
  { emoji: "🛻", name: "pickup truck", section: "การเดินทาง" },
  { emoji: "🚚", name: "delivery truck", section: "การเดินทาง" },
  { emoji: "🚛", name: "lorry articulated", section: "การเดินทาง" },
  { emoji: "🚜", name: "tractor farm", section: "การเดินทาง" },
  { emoji: "🏍️", name: "motorcycle motorbike", section: "การเดินทาง" },
  { emoji: "🛵", name: "motor scooter", section: "การเดินทาง" },
  { emoji: "🚲", name: "bicycle bike", section: "การเดินทาง" },
  { emoji: "🛴", name: "kick scooter", section: "การเดินทาง" },
  { emoji: "🛺", name: "auto rickshaw tuk tuk", section: "การเดินทาง" },
  { emoji: "🚁", name: "helicopter", section: "การเดินทาง" },
  { emoji: "🛸", name: "flying saucer ufo", section: "การเดินทาง" },
  { emoji: "🚀", name: "rocket space", section: "การเดินทาง" },
  { emoji: "✈️", name: "airplane flight", section: "การเดินทาง" },
  { emoji: "🛩️", name: "small airplane", section: "การเดินทาง" },
  { emoji: "🛫", name: "airplane departure", section: "การเดินทาง" },
  { emoji: "🛬", name: "airplane arriving landing", section: "การเดินทาง" },
  { emoji: "💺", name: "seat", section: "การเดินทาง" },
  { emoji: "🚂", name: "locomotive train steam", section: "การเดินทาง" },
  { emoji: "🚄", name: "bullet train shinkansen", section: "การเดินทาง" },
  { emoji: "🚆", name: "train", section: "การเดินทาง" },
  { emoji: "🚇", name: "metro subway", section: "การเดินทาง" },
  { emoji: "🚊", name: "tram", section: "การเดินทาง" },
  { emoji: "🚢", name: "ship cruise", section: "การเดินทาง" },
  { emoji: "⛵", name: "sailboat", section: "การเดินทาง" },
  { emoji: "🚤", name: "speedboat", section: "การเดินทาง" },
  { emoji: "⛽", name: "fuel pump gas station", section: "การเดินทาง" },
  { emoji: "🚦", name: "traffic light", section: "การเดินทาง" },
  { emoji: "🚧", name: "construction barrier", section: "การเดินทาง" },
  { emoji: "⚓", name: "anchor", section: "การเดินทาง" },
  { emoji: "🏠", name: "house home", section: "การเดินทาง" },
  { emoji: "🏡", name: "house garden", section: "การเดินทาง" },
  { emoji: "🏢", name: "office building", section: "การเดินทาง" },
  { emoji: "🏥", name: "hospital", section: "การเดินทาง" },
  { emoji: "🏦", name: "bank", section: "การเดินทาง" },
  { emoji: "🏨", name: "hotel", section: "การเดินทาง" },
  { emoji: "🏪", name: "convenience store", section: "การเดินทาง" },
  { emoji: "🏫", name: "school", section: "การเดินทาง" },
  { emoji: "🏬", name: "department store", section: "การเดินทาง" },
  { emoji: "🏭", name: "factory", section: "การเดินทาง" },
  { emoji: "🏯", name: "japanese castle", section: "การเดินทาง" },
  { emoji: "🏰", name: "european castle", section: "การเดินทาง" },
  { emoji: "🗼", name: "tokyo tower", section: "การเดินทาง" },
  { emoji: "🗽", name: "statue of liberty", section: "การเดินทาง" },
  { emoji: "⛪", name: "church", section: "การเดินทาง" },
  { emoji: "🕌", name: "mosque", section: "การเดินทาง" },
  { emoji: "⛩️", name: "shinto shrine", section: "การเดินทาง" },
  { emoji: "🕋", name: "kaaba mecca", section: "การเดินทาง" },
  { emoji: "⛲", name: "fountain", section: "การเดินทาง" },
  { emoji: "⛺", name: "tent camping", section: "การเดินทาง" },
  { emoji: "🏕️", name: "camping", section: "การเดินทาง" },
  { emoji: "🏖️", name: "beach umbrella", section: "การเดินทาง" },
  { emoji: "🏜️", name: "desert", section: "การเดินทาง" },
  { emoji: "🏝️", name: "desert island", section: "การเดินทาง" },
  { emoji: "🏞️", name: "national park", section: "การเดินทาง" },
  { emoji: "🌁", name: "foggy bridge", section: "การเดินทาง" },
  { emoji: "🌃", name: "night stars city", section: "การเดินทาง" },
  { emoji: "🏙️", name: "cityscape city", section: "การเดินทาง" },
  { emoji: "🌅", name: "sunrise", section: "การเดินทาง" },
  { emoji: "🌆", name: "cityscape dusk", section: "การเดินทาง" },
  { emoji: "🌇", name: "sunset", section: "การเดินทาง" },
  { emoji: "🌉", name: "bridge at night", section: "การเดินทาง" },
  { emoji: "🗺️", name: "world map", section: "การเดินทาง" },
  { emoji: "🧭", name: "compass", section: "การเดินทาง" },
  { emoji: "🏔️", name: "snow mountain", section: "การเดินทาง" },
  { emoji: "⛰️", name: "mountain", section: "การเดินทาง" },
  { emoji: "🗻", name: "mount fuji", section: "การเดินทาง" },
  { emoji: "🌐", name: "globe meridians world", section: "การเดินทาง" },
  { emoji: "🌍", name: "globe europe africa", section: "การเดินทาง" },
  { emoji: "🌎", name: "globe americas", section: "การเดินทาง" },
  { emoji: "🌏", name: "globe asia australia", section: "การเดินทาง" },

  // ── Objects ───────────────────────────────────────────────────────────────
  { emoji: "⌚", name: "watch wristwatch", section: "สิ่งของ" },
  { emoji: "📱", name: "mobile phone smartphone", section: "สิ่งของ" },
  { emoji: "💻", name: "laptop computer", section: "สิ่งของ" },
  { emoji: "⌨️", name: "keyboard", section: "สิ่งของ" },
  { emoji: "🖥️", name: "desktop computer monitor", section: "สิ่งของ" },
  { emoji: "🖨️", name: "printer", section: "สิ่งของ" },
  { emoji: "🖱️", name: "computer mouse", section: "สิ่งของ" },
  { emoji: "💽", name: "computer disk", section: "สิ่งของ" },
  { emoji: "💾", name: "floppy disk", section: "สิ่งของ" },
  { emoji: "💿", name: "optical disk cd", section: "สิ่งของ" },
  { emoji: "📀", name: "dvd disc", section: "สิ่งของ" },
  { emoji: "🧮", name: "abacus calculator", section: "สิ่งของ" },
  { emoji: "📷", name: "camera photo", section: "สิ่งของ" },
  { emoji: "📸", name: "camera flash", section: "สิ่งของ" },
  { emoji: "📹", name: "video camera", section: "สิ่งของ" },
  { emoji: "🎥", name: "movie camera film", section: "สิ่งของ" },
  { emoji: "📞", name: "telephone receiver", section: "สิ่งของ" },
  { emoji: "☎️", name: "telephone", section: "สิ่งของ" },
  { emoji: "📟", name: "pager", section: "สิ่งของ" },
  { emoji: "📠", name: "fax machine", section: "สิ่งของ" },
  { emoji: "📺", name: "television tv", section: "สิ่งของ" },
  { emoji: "📻", name: "radio", section: "สิ่งของ" },
  { emoji: "⏰", name: "alarm clock", section: "สิ่งของ" },
  { emoji: "⌛", name: "hourglass done", section: "สิ่งของ" },
  { emoji: "⏳", name: "hourglass sand", section: "สิ่งของ" },
  { emoji: "📡", name: "satellite antenna", section: "สิ่งของ" },
  { emoji: "🔋", name: "battery", section: "สิ่งของ" },
  { emoji: "🔌", name: "electric plug", section: "สิ่งของ" },
  { emoji: "💡", name: "light bulb idea", section: "สิ่งของ" },
  { emoji: "🔦", name: "flashlight torch", section: "สิ่งของ" },
  { emoji: "🕯️", name: "candle", section: "สิ่งของ" },
  { emoji: "💰", name: "money bag", section: "สิ่งของ" },
  { emoji: "🪙", name: "coin", section: "สิ่งของ" },
  { emoji: "💵", name: "dollar banknote", section: "สิ่งของ" },
  { emoji: "💴", name: "yen banknote", section: "สิ่งของ" },
  { emoji: "💶", name: "euro banknote", section: "สิ่งของ" },
  { emoji: "💷", name: "pound banknote", section: "สิ่งของ" },
  { emoji: "💸", name: "money with wings", section: "สิ่งของ" },
  { emoji: "💳", name: "credit card payment", section: "สิ่งของ" },
  { emoji: "📈", name: "chart increasing profit", section: "สิ่งของ" },
  { emoji: "📉", name: "chart decreasing loss", section: "สิ่งของ" },
  { emoji: "📊", name: "bar chart graph", section: "สิ่งของ" },
  { emoji: "📋", name: "clipboard", section: "สิ่งของ" },
  { emoji: "📁", name: "file folder", section: "สิ่งของ" },
  { emoji: "📂", name: "open file folder", section: "สิ่งของ" },
  { emoji: "📅", name: "calendar date", section: "สิ่งของ" },
  { emoji: "📆", name: "tear off calendar", section: "สิ่งของ" },
  { emoji: "📇", name: "card index", section: "สิ่งของ" },
  { emoji: "📌", name: "pushpin pin", section: "สิ่งของ" },
  { emoji: "📍", name: "round pushpin location", section: "สิ่งของ" },
  { emoji: "📎", name: "paperclip", section: "สิ่งของ" },
  { emoji: "📏", name: "straight ruler", section: "สิ่งของ" },
  { emoji: "📐", name: "triangular ruler", section: "สิ่งของ" },
  { emoji: "✂️", name: "scissors cut", section: "สิ่งของ" },
  { emoji: "🗑️", name: "wastebasket trash", section: "สิ่งของ" },
  { emoji: "🔒", name: "locked secure", section: "สิ่งของ" },
  { emoji: "🔓", name: "unlocked open", section: "สิ่งของ" },
  { emoji: "🔑", name: "key", section: "สิ่งของ" },
  { emoji: "🗝️", name: "old key", section: "สิ่งของ" },
  { emoji: "🔨", name: "hammer", section: "สิ่งของ" },
  { emoji: "🪓", name: "axe", section: "สิ่งของ" },
  { emoji: "⛏️", name: "pick axe mining", section: "สิ่งของ" },
  { emoji: "🛠️", name: "hammer wrench tools", section: "สิ่งของ" },
  { emoji: "⚔️", name: "crossed swords", section: "สิ่งของ" },
  { emoji: "🛡️", name: "shield", section: "สิ่งของ" },
  { emoji: "🔧", name: "wrench repair", section: "สิ่งของ" },
  { emoji: "🪛", name: "screwdriver", section: "สิ่งของ" },
  { emoji: "🔩", name: "nut bolt", section: "สิ่งของ" },
  { emoji: "⚙️", name: "gear settings", section: "สิ่งของ" },
  { emoji: "⚖️", name: "balance scale justice", section: "สิ่งของ" },
  { emoji: "🔗", name: "link chain", section: "สิ่งของ" },
  { emoji: "🧲", name: "magnet", section: "สิ่งของ" },
  { emoji: "🪜", name: "ladder", section: "สิ่งของ" },
  { emoji: "⚗️", name: "alembic chemistry", section: "สิ่งของ" },
  { emoji: "🧪", name: "test tube lab", section: "สิ่งของ" },
  { emoji: "🧫", name: "petri dish", section: "สิ่งของ" },
  { emoji: "🧬", name: "dna genetics", section: "สิ่งของ" },
  { emoji: "🔭", name: "telescope astronomy", section: "สิ่งของ" },
  { emoji: "🔬", name: "microscope science", section: "สิ่งของ" },
  { emoji: "🩺", name: "stethoscope doctor", section: "สิ่งของ" },
  { emoji: "💊", name: "pill medicine", section: "สิ่งของ" },
  { emoji: "💉", name: "syringe injection", section: "สิ่งของ" },
  { emoji: "🩹", name: "adhesive bandage", section: "สิ่งของ" },
  { emoji: "🧰", name: "toolbox", section: "สิ่งของ" },
  { emoji: "🪞", name: "mirror", section: "สิ่งของ" },
  { emoji: "🛏️", name: "bed sleep", section: "สิ่งของ" },
  { emoji: "🛋️", name: "couch sofa", section: "สิ่งของ" },
  { emoji: "🪑", name: "chair seat", section: "สิ่งของ" },
  { emoji: "🚽", name: "toilet", section: "สิ่งของ" },
  { emoji: "🚿", name: "shower", section: "สิ่งของ" },
  { emoji: "🛁", name: "bathtub bath", section: "สิ่งของ" },
  { emoji: "🧴", name: "lotion bottle", section: "สิ่งของ" },
  { emoji: "🧷", name: "safety pin", section: "สิ่งของ" },
  { emoji: "🧹", name: "broom sweep", section: "สิ่งของ" },
  { emoji: "🧺", name: "basket laundry", section: "สิ่งของ" },
  { emoji: "🧻", name: "roll of paper toilet", section: "สิ่งของ" },
  { emoji: "🪣", name: "bucket", section: "สิ่งของ" },
  { emoji: "🧼", name: "soap wash", section: "สิ่งของ" },
  { emoji: "🪥", name: "toothbrush", section: "สิ่งของ" },
  { emoji: "🧽", name: "sponge clean", section: "สิ่งของ" },
  { emoji: "🛒", name: "shopping cart", section: "สิ่งของ" },
  { emoji: "🚪", name: "door", section: "สิ่งของ" },
  { emoji: "📦", name: "package box parcel", section: "สิ่งของ" },
  { emoji: "📫", name: "mailbox", section: "สิ่งของ" },
  { emoji: "📮", name: "postbox", section: "สิ่งของ" },
  { emoji: "✏️", name: "pencil write", section: "สิ่งของ" },
  { emoji: "✒️", name: "black nib pen", section: "สิ่งของ" },
  { emoji: "🖊️", name: "pen", section: "สิ่งของ" },
  { emoji: "🖌️", name: "paintbrush", section: "สิ่งของ" },
  { emoji: "🖍️", name: "crayon", section: "สิ่งของ" },
  { emoji: "📝", name: "memo note write", section: "สิ่งของ" },
  { emoji: "📓", name: "notebook", section: "สิ่งของ" },
  { emoji: "📚", name: "books stack", section: "สิ่งของ" },
  { emoji: "📖", name: "open book reading", section: "สิ่งของ" },
  { emoji: "🔖", name: "bookmark", section: "สิ่งของ" },
  { emoji: "🏷️", name: "label tag price", section: "สิ่งของ" },
  { emoji: "🔍", name: "magnifying glass search", section: "สิ่งของ" },
  { emoji: "🔎", name: "magnifying glass zoom", section: "สิ่งของ" },

  // ── Symbols ───────────────────────────────────────────────────────────────
  { emoji: "❤️", name: "red heart love", section: "สัญลักษณ์" },
  { emoji: "🧡", name: "orange heart", section: "สัญลักษณ์" },
  { emoji: "💛", name: "yellow heart", section: "สัญลักษณ์" },
  { emoji: "💚", name: "green heart", section: "สัญลักษณ์" },
  { emoji: "💙", name: "blue heart", section: "สัญลักษณ์" },
  { emoji: "💜", name: "purple heart", section: "สัญลักษณ์" },
  { emoji: "🖤", name: "black heart", section: "สัญลักษณ์" },
  { emoji: "🤍", name: "white heart", section: "สัญลักษณ์" },
  { emoji: "🤎", name: "brown heart", section: "สัญลักษณ์" },
  { emoji: "💔", name: "broken heart", section: "สัญลักษณ์" },
  { emoji: "❤️‍🔥", name: "heart on fire passion", section: "สัญลักษณ์" },
  { emoji: "❣️", name: "heart exclamation", section: "สัญลักษณ์" },
  { emoji: "💕", name: "two hearts", section: "สัญลักษณ์" },
  { emoji: "💞", name: "revolving hearts", section: "สัญลักษณ์" },
  { emoji: "💓", name: "beating heart", section: "สัญลักษณ์" },
  { emoji: "💗", name: "growing heart", section: "สัญลักษณ์" },
  { emoji: "💖", name: "sparkling heart", section: "สัญลักษณ์" },
  { emoji: "💘", name: "heart with arrow", section: "สัญลักษณ์" },
  { emoji: "💝", name: "heart with ribbon", section: "สัญลักษณ์" },
  { emoji: "✅", name: "check mark done", section: "สัญลักษณ์" },
  { emoji: "❌", name: "cross mark cancel", section: "สัญลักษณ์" },
  { emoji: "⭕", name: "hollow red circle ok", section: "สัญลักษณ์" },
  { emoji: "❓", name: "question mark", section: "สัญลักษณ์" },
  { emoji: "❗", name: "exclamation mark", section: "สัญลักษณ์" },
  { emoji: "⚠️", name: "warning caution", section: "สัญลักษณ์" },
  { emoji: "🚨", name: "police light alert", section: "สัญลักษณ์" },
  { emoji: "🚫", name: "prohibited no", section: "สัญลักษณ์" },
  { emoji: "🔞", name: "no under 18", section: "สัญลักษณ์" },
  { emoji: "🔴", name: "red circle", section: "สัญลักษณ์" },
  { emoji: "🟠", name: "orange circle", section: "สัญลักษณ์" },
  { emoji: "🟡", name: "yellow circle", section: "สัญลักษณ์" },
  { emoji: "🟢", name: "green circle", section: "สัญลักษณ์" },
  { emoji: "🔵", name: "blue circle", section: "สัญลักษณ์" },
  { emoji: "🟣", name: "purple circle", section: "สัญลักษณ์" },
  { emoji: "⚫", name: "black circle", section: "สัญลักษณ์" },
  { emoji: "⚪", name: "white circle", section: "สัญลักษณ์" },
  { emoji: "🟥", name: "red square", section: "สัญลักษณ์" },
  { emoji: "🟧", name: "orange square", section: "สัญลักษณ์" },
  { emoji: "🟨", name: "yellow square", section: "สัญลักษณ์" },
  { emoji: "🟩", name: "green square", section: "สัญลักษณ์" },
  { emoji: "🟦", name: "blue square", section: "สัญลักษณ์" },
  { emoji: "🟪", name: "purple square", section: "สัญลักษณ์" },
  { emoji: "⬛", name: "black square", section: "สัญลักษณ์" },
  { emoji: "⬜", name: "white square", section: "สัญลักษณ์" },
  { emoji: "🔶", name: "large orange diamond", section: "สัญลักษณ์" },
  { emoji: "🔷", name: "large blue diamond", section: "สัญลักษณ์" },
  { emoji: "🔸", name: "small orange diamond", section: "สัญลักษณ์" },
  { emoji: "🔹", name: "small blue diamond", section: "สัญลักษณ์" },
  { emoji: "🔺", name: "red triangle up", section: "สัญลักษณ์" },
  { emoji: "🔻", name: "red triangle down", section: "สัญลักษณ์" },
  { emoji: "💠", name: "diamond dot", section: "สัญลักษณ์" },
  { emoji: "🔥", name: "fire hot flame", section: "สัญลักษณ์" },
  { emoji: "💥", name: "collision boom", section: "สัญลักษณ์" },
  { emoji: "✨", name: "sparkles shine", section: "สัญลักษณ์" },
  { emoji: "🎉", name: "party tada celebration", section: "สัญลักษณ์" },
  { emoji: "🎊", name: "confetti ball party", section: "สัญลักษณ์" },
  { emoji: "🎈", name: "balloon party", section: "สัญลักษณ์" },
  { emoji: "🎁", name: "gift present", section: "สัญลักษณ์" },
  { emoji: "🎀", name: "ribbon bow", section: "สัญลักษณ์" },
  { emoji: "🏳️", name: "white flag", section: "สัญลักษณ์" },
  { emoji: "🏴", name: "black flag", section: "สัญลักษณ์" },
  { emoji: "🚩", name: "red flag triangular", section: "สัญลักษณ์" },
  { emoji: "🏁", name: "chequered flag racing", section: "สัญลักษณ์" },
  { emoji: "⬆️", name: "up arrow", section: "สัญลักษณ์" },
  { emoji: "➡️", name: "right arrow", section: "สัญลักษณ์" },
  { emoji: "⬇️", name: "down arrow", section: "สัญลักษณ์" },
  { emoji: "⬅️", name: "left arrow", section: "สัญลักษณ์" },
  { emoji: "↗️", name: "up right arrow", section: "สัญลักษณ์" },
  { emoji: "↘️", name: "down right arrow", section: "สัญลักษณ์" },
  { emoji: "↙️", name: "down left arrow", section: "สัญลักษณ์" },
  { emoji: "↖️", name: "up left arrow", section: "สัญลักษณ์" },
  { emoji: "↕️", name: "up down arrow", section: "สัญลักษณ์" },
  { emoji: "↔️", name: "left right arrow", section: "สัญลักษณ์" },
  { emoji: "🔄", name: "counterclockwise arrows refresh", section: "สัญลักษณ์" },
  { emoji: "🔃", name: "clockwise arrows reload", section: "สัญลักษณ์" },
  { emoji: "🔀", name: "shuffle random", section: "สัญลักษณ์" },
  { emoji: "🔁", name: "repeat loop", section: "สัญลักษณ์" },
  { emoji: "▶️", name: "play button", section: "สัญลักษณ์" },
  { emoji: "⏩", name: "fast forward", section: "สัญลักษณ์" },
  { emoji: "⏸️", name: "pause button", section: "สัญลักษณ์" },
  { emoji: "⏹️", name: "stop button", section: "สัญลักษณ์" },
  { emoji: "🔔", name: "bell notification", section: "สัญลักษณ์" },
  { emoji: "🔕", name: "bell slash mute", section: "สัญลักษณ์" },
  { emoji: "🔇", name: "muted speaker", section: "สัญลักษณ์" },
  { emoji: "🔊", name: "loud speaker volume", section: "สัญลักษณ์" },
  { emoji: "📢", name: "loudspeaker announce", section: "สัญลักษณ์" },
  { emoji: "📣", name: "megaphone", section: "สัญลักษณ์" },
  { emoji: "💬", name: "speech bubble chat", section: "สัญลักษณ์" },
  { emoji: "💭", name: "thought bubble thinking", section: "สัญลักษณ์" },
  { emoji: "🗨️", name: "speech balloon", section: "สัญลักษณ์" },
  { emoji: "♻️", name: "recycling symbol eco", section: "สัญลักษณ์" },
  { emoji: "✔️", name: "check mark tick", section: "สัญลักษณ์" },
  { emoji: "☑️", name: "check box", section: "สัญลักษณ์" },
  { emoji: "🔱", name: "trident emblem", section: "สัญลักษณ์" },
  { emoji: "⚜️", name: "fleur de lis", section: "สัญลักษณ์" },
  { emoji: "📛", name: "name badge", section: "สัญลักษณ์" },
  { emoji: "🔰", name: "japanese beginner", section: "สัญลักษณ์" },
  { emoji: "⭐", name: "star", section: "สัญลักษณ์" },
  { emoji: "🌟", name: "glowing star shine", section: "สัญลักษณ์" },
  { emoji: "💫", name: "dizzy star", section: "สัญลักษณ์" },
  { emoji: "☮️", name: "peace symbol", section: "สัญลักษณ์" },
  { emoji: "☯️", name: "yin yang", section: "สัญลักษณ์" },
  { emoji: "☢️", name: "radioactive", section: "สัญลักษณ์" },
  { emoji: "☣️", name: "biohazard", section: "สัญลักษณ์" },
  { emoji: "🆘", name: "sos emergency", section: "สัญลักษณ์" },
  { emoji: "🆒", name: "cool button", section: "สัญลักษณ์" },
  { emoji: "🆕", name: "new button", section: "สัญลักษณ์" },
  { emoji: "🆓", name: "free button", section: "สัญลักษณ์" },
  { emoji: "🆙", name: "up button", section: "สัญลักษณ์" },
  { emoji: "🆗", name: "ok button", section: "สัญลักษณ์" },
  { emoji: "©️", name: "copyright", section: "สัญลักษณ์" },
  { emoji: "®️", name: "registered trademark", section: "สัญลักษณ์" },
  { emoji: "™️", name: "trade mark", section: "สัญลักษณ์" },
  { emoji: "ℹ️", name: "information", section: "สัญลักษณ์" },
  { emoji: "🔅", name: "dim button brightness low", section: "สัญลักษณ์" },
  { emoji: "🔆", name: "bright button brightness high", section: "สัญลักษณ์" },
  { emoji: "📶", name: "antenna bars signal", section: "สัญลักษณ์" },
  { emoji: "♾️", name: "infinity", section: "สัญลักษณ์" },
  { emoji: "‼️", name: "double exclamation", section: "สัญลักษณ์" },
  { emoji: "⁉️", name: "exclamation question", section: "สัญลักษณ์" },
  { emoji: "💲", name: "dollar sign currency", section: "สัญลักษณ์" },
  { emoji: "💱", name: "currency exchange", section: "สัญลักษณ์" },
];

const SECTIONS = ["หน้าตา", "ท่าทาง", "เครื่องแต่งกาย", "สัตว์และธรรมชาติ", "อาหารและเครื่องดื่ม", "กิจกรรมและกีฬา", "การเดินทาง", "สิ่งของ", "สัญลักษณ์"];

interface DialogProviderEmojiPickerPortalProps {
  onClose: (emoji: string | null) => void;
}

export const DialogProviderEmojiPickerPortal = ({ onClose }: DialogProviderEmojiPickerPortalProps) => {
  const [search, setSearch] = useState("");
  const [activeSection, setActiveSection] = useState<string>("หน้าตา");

  const filtered = search.trim()
    ? EMOJI_LIST.filter(e =>
      e.name.includes(search.toLowerCase()) ||
      e.emoji.includes(search) ||
      e.section.toLowerCase().includes(search.toLowerCase())
    )
    : EMOJI_LIST.filter(e => e.section === activeSection);

  return ReactDOM.createPortal(
    <div style={backdropStyle} onClick={() => onClose(null)}>
      <div
        style={{ ...modalStyle, maxWidth: 480, padding: 20, display: "flex", flexDirection: "column", height: "520px" }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <h5 style={{ margin: 0 }}>เลือก Icon</h5>
          <button className="btn-close" onClick={() => onClose(null)} style={{ fontSize: "0.8rem" }} />
        </div>

        {/* Search */}
        <input
          className="form-control form-control-sm mb-2"
          placeholder="ค้นหา emoji..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoFocus
        />

        {/* Section tabs — only when not searching */}
        {!search.trim() && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 8 }}>
            {SECTIONS.map(sec => (
              <button
                key={sec}
                onClick={() => setActiveSection(sec)}
                style={{
                  fontSize: "0.72rem",
                  padding: "2px 8px",
                  borderRadius: 12,
                  border: "1px solid",
                  cursor: "pointer",
                  background: activeSection === sec ? "var(--bs-primary, #0d6efd)" : "transparent",
                  color: activeSection === sec ? "#fff" : "inherit",
                  borderColor: activeSection === sec ? "var(--bs-primary, #0d6efd)" : "var(--bs-border-color, #ccc)",
                  transition: "all 0.15s",
                }}
              >
                {sec}
              </button>
            ))}
          </div>
        )}

        {/* Emoji grid */}
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(9, 1fr)",
          gap: 2,
          overflowY: "auto",
          flex: 1,
        }}>
          {filtered.map(({ emoji, name }) => (
            <button
              key={emoji + name}
              title={name}
              onClick={() => onClose(emoji)}
              style={{
                background: "none",
                border: "1px solid transparent",
                borderRadius: 6,
                fontSize: "1.4rem",
                cursor: "pointer",
                padding: "4px 2px",
                lineHeight: 1,
                transition: "background 0.12s, border-color 0.12s",
              }}
              onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.background = "var(--bs-primary-bg-subtle, #e8f0fe)";
                (e.currentTarget as HTMLButtonElement).style.borderColor = "var(--bs-primary, #0d6efd)";
              }}
              onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.background = "none";
                (e.currentTarget as HTMLButtonElement).style.borderColor = "transparent";
              }}
            >
              {emoji}
            </button>
          ))}
          {filtered.length === 0 && (
            <div style={{ gridColumn: "1 / -1", textAlign: "center", color: "#888", padding: "20px 0", fontSize: "0.9rem" }}>
              ไม่พบ emoji
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={{ marginTop: 10, display: "flex", justifyContent: "flex-end" }}>
          <button className="btn btn-sm btn-secondary" onClick={() => onClose(null)}>ยกเลิก</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
